import React, {  useState } from "react";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useNavigate } from "react-router-dom";
// import axiosInstance from "@/api/axios";
import toastService from "@/services/toastService";
import axiosInstance from "@/api/axios";

interface FormValues {
  currentPassword: string;
  password: string;
  confirmPassword: string;
}

interface FormErrors {
  currentPassword?: string;
  password?: string;
  confirmPassword?: string;
}


const labelStyle = "block text-left text-sm font-medium mb-2";
const errorStyle = "text-red-500 text-left text-xs mt-1";
const buttonStyle = "w-full text-lg font-semibold py-2 px-4 rounded-lg";

const ChangePassword: React.FC = () => {

  const [formValues, setFormValues] = useState<FormValues>({
    currentPassword: "",
    password: "",
    confirmPassword: "",
  });

  const [formErrors, setFormErrors] = useState<FormErrors>({});
  const [showCurrentPassword, setShowCurrentPassword] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);

  const navigate = useNavigate();


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });

    if (formErrors[name as keyof FormErrors]) {
      setFormErrors({ ...formErrors, [name]: undefined });
    }
  };

  const validateForm = (): boolean => {
    const errors: FormErrors = {};

    if (!formValues.currentPassword) {
      errors.currentPassword = "Current password is required";
    }
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;

    if (!formValues.password) {
      errors.password = "New password is required";
    } else if (!passwordRegex.test(formValues.password)) {
      errors.password =  "Password must be at least 6 characters, include one uppercase letter, one lowercase letter, one number, and one special character";;
    }

    if (!formValues.confirmPassword) {
      errors.confirmPassword = "Confirm password is required";
    } else if (formValues.confirmPassword !== formValues.password) {
      errors.confirmPassword = "Passwords do not match";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

const handleNewPassword = async (e: React.FormEvent) => {
  e.preventDefault();

  if (validateForm()) {
    try {
      const response = await axiosInstance.put("/user/api/v1/user/changePassword", {
        currentPassword: formValues.currentPassword,
        newPassword: formValues.password,
      });

      if (response.status === 200) {
        toastService.success("Password updated successfully.");
        localStorage.removeItem("user");
        localStorage.removeItem("accessToken"); 
        navigate("/auth/login");
      } else {
        toastService.error(response.data?.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }
};


  return (
    <div className="h-[90vh] flex flex-col overflow-hidden">
      <main className="flex-grow flex flex-col items-center justify-center px-4 relative z-10">
        <div className="w-full max-w-[30rem] 2xl:max-w-xl p-8 bg-white bg-opacity-90 rounded-lg">
          <h2 className="text-2xl font-semibold text-center mb-12 z-10">
            Change Password
          </h2>

          <form onSubmit={handleNewPassword}>
            {/* Current Password */}
            <div className="mb-4">
              <label htmlFor="currentPassword" className={labelStyle}>
                Current Password
              </label>
              <div className="relative">
                <Input
                  id="currentPassword"
                  name="currentPassword"
                  type={showCurrentPassword ? "text" : "password"}
                  placeholder="Enter Current Password"
                  value={formValues.currentPassword}
                  onChange={handleChange}
                  className={`w-full pr-10 rounded-lg ${formErrors.currentPassword ? "border-red-500" : ""}`}
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 flex items-center pr-3"
                  onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                >
                  {showCurrentPassword ? (
                    <IoMdEyeOff className="h-6 w-6" fill="#828282" />
                  ) : (
                    <IoMdEye className="h-6 w-6" fill="#828282" />
                  )}
                </button>
              </div>
              {formErrors.currentPassword && (
                <p className={errorStyle}>{formErrors.currentPassword}</p>
              )}
            </div>

            {/* New Password */}
            <div className="mb-4">
              <label htmlFor="password" className={labelStyle}>
                New Password
              </label>
              <div className="relative">
                <Input
                  id="password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter New Password"
                  value={formValues.password}
                  onChange={handleChange}
                  className={`w-full pr-10 rounded-lg ${formErrors.password ? "border-red-500" : ""}`}
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 flex items-center pr-3"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <IoMdEyeOff className="h-6 w-6" fill="#828282" />
                  ) : (
                    <IoMdEye className="h-6 w-6" fill="#828282" />
                  )}
                </button>
              </div>
              {formErrors.password && (
                <p className={errorStyle}>{formErrors.password}</p>
              )}
            </div>

            {/* Confirm Password */}
            <div className="mb-4">
              <label htmlFor="confirmPassword" className={labelStyle}>
                Confirm Password
              </label>
              <div className="relative">
                <Input
                  id="confirmPassword"
                  name="confirmPassword"
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm Password"
                  value={formValues.confirmPassword}
                  onChange={handleChange}
                  className={`w-full pr-10 rounded-lg ${formErrors.confirmPassword ? "border-red-500" : ""}`}
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 flex items-center pr-3"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? (
                    <IoMdEyeOff className="h-6 w-6" fill="#828282" />
                  ) : (
                    <IoMdEye className="h-6 w-6" fill="#828282" />
                  )}
                </button>
              </div>
              {formErrors.confirmPassword && (
                <p className={errorStyle}>{formErrors.confirmPassword}</p>
              )}
            </div>

            {/* Submit button */}
            <Button
              type="submit"
              className={`${buttonStyle} bg-[#28af4a] hover:bg-[#28af4a]/90 text-white mb-4`}
            >
              Save Changes
            </Button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default ChangePassword;
